function escapeRegExp(s: string): string {
  return s.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

/**
 * Highlights whitespace-separated query terms inside plain text (case-insensitive).
 */
export function HighlightedText({
  className,
  query,
  text,
}: {
  className?: string;
  query: string;
  text: string;
}) {
  const terms = query
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter((t) => t.length > 1);

  if (terms.length === 0) {
    return <span className={className}>{text}</span>;
  }

  const pattern = new RegExp(`(${terms.map(escapeRegExp).join("|")})`, "gi");
  const parts = text.split(pattern);

  return (
    <span className={className}>
      {parts.map((part, i) => {
        const hit = terms.some((t) => part.toLowerCase() === t);

        return hit ? (
          <mark
            key={i}
            className="rounded bg-warning-200 px-0.5 font-inherit dark:bg-warning-400/35"
          >
            {part}
          </mark>
        ) : (
          <span key={i}>{part}</span>
        );
      })}
    </span>
  );
}
